import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import Spinner from 'modules/common/spinner.component';
import { Box, Card, CardContent, Checkbox, Tooltip, Typography } from '@mui/material';
import CrudTable from 'modules/clients/details/crudTable.component';
import { enumColumn, useEnumColumns } from 'modules/common/enumTableColumn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo, useState } from 'react';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const BankingCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  const { currencyColumn } = useEnumColumns();

  const {
    banks,
    isReadOnly,
    updateBankFunc,
    createBankFunc,
    deleteBankFunc,
    // renderCountryOptionsEnum,
    statusTypesEnum,
    currencyOptionsEnum,
    fileId,
    authorizationAddress = [],
    paymentMethodTypesEnum,
    provinceOptionsEnum
  } = props;

  const PAYMENT_TYPES = {
    ACH: 'a7f3e8b1-2d4c-4e9a-8f6b-1c5d7a9e2b3f',
    INTERNATIONAL_WIRE: 'b8e4f9c2-3e5d-4f0b-9a7c-2d6e8b0f3c4a',
    WIRE: 'c9f5a0d3-4f6e-5a1c-0b8d-3e7f9c1a4d5b',
    CASH: 'd0a6b1e4-5a7f-6b2d-1c9e-4f8a0d2b5e6c',
    CHECK: 'e1b7c2f5-6b8a-7c3e-2d0f-5a9b1e3c6f7d'
  };

  const bankAddresses = useMemo(() => {
    if (!authorizationAddress || authorizationAddress.length === 0) {
      return [{ id: 0, title: 'N/a' }];
    }

    const items = authorizationAddress
      .filter(a => a && a.addressId)
      .map(a => {
        const state = provinceOptionsEnum ? provinceOptionsEnum.find(p => p.id === a.provinceId)?.code ?? '' : '';
        // const country = renderCountryOptionsEnum ? renderCountryOptionsEnum.find(c => c.id === a.countryId)?.countryCode ?? '' : '';
        const formattedAddress = `${a.addressLine1 ?? a.address1 ?? ''} ${a.addressLine2 ?? a.address2 ?? ''} ${a.city ?? a.city ?? ''}, ${a.zipcode ?? a.zipCode ?? ''} ${state}`.trim();
        const title = formattedAddress || 'Address';
        return { id: a.addressId, title };
      });

    return items.length > 0 ? items : [{ id: 0, title: 'N/a' }];
  }, [authorizationAddress, provinceOptionsEnum]);

  // const accountTypes =
  //   accountTypesEnum && accountTypesEnum.length > 0 ? accountTypesEnum.filter(s => s.isActive === true) : [{ id: EMPTY_GUID, title: '' }];

  const statusTypes =
    statusTypesEnum && statusTypesEnum.length > 0 ? statusTypesEnum.filter(s => s.isActive === true) : [{ id: EMPTY_GUID, title: '' }];

  const currencyOptions =
    currencyOptionsEnum && currencyOptionsEnum.length > 0
      ? currencyOptionsEnum.filter(s => s.isActive === true)
      : [{ id: EMPTY_GUID, title: '' }];

  // const accountLocation =
  //   accountLocationEnum && accountLocationEnum.length > 0
  //     ? accountLocationEnum.filter(s => s.isActive === true)
  //     : [{ id: EMPTY_GUID, title: '' }];

  const paymentTypes =
    paymentMethodTypesEnum && paymentMethodTypesEnum.length > 0
      ? paymentMethodTypesEnum.filter(s => s.isActive === true)
      : [{ id: EMPTY_GUID, title: '' }];

  // const provinces =
  //   provinceOptionsEnum && provinceOptionsEnum.length > 0
  //     ? provinceOptionsEnum.filter(s => s.isActive === true)
  //     : [{ id: EMPTY_GUID, title: '' }];

  let bankingSummaries = [
    {
      header: 'General Information',
      accessorKey: 'generalInformation',
      type: 'title',
      categoryType: 'general',
      tab: 1,
      gridSize: 12,
      hideInTable: true
    },
    {
      header: 'Empty',
      accessorKey: 'emptyElement1',
      type: 'hidden',
      required: false,
      categoryType: 'general',
      tab: 1,
      hideInTable: true
      // hideInModel: true,
    },
    {
      header: 'Empty',
      accessorKey: 'emptyElement2',
      type: 'hidden',
      required: false,
      categoryType: 'general',
      tab: 1,
      hideInTable: true
      // hideInModel: true,
    },


    {
      header: 'Payment Type',
      ...enumColumn('paymentTypeId', paymentTypes),
      type: 'dropdown-v2',
      options: paymentTypes,
      required: true,
      categoryType: 'general',
      tab: 1,
      size: 100,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
    },
    {
      header: 'Bank Nickname',
      accessorKey: 'bankNickName',
      type: 'text',
      required: true,
      categoryType: 'general',
      tab: 1,
      size: 100,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    // {
    //   header: 'Account Location',
    //   accessorKey: 'accountLocationId',
    //   type: 'dropdown-v2',
    //   options: accountLocation,
    //   required: false,
    //   categoryType: 'general',
    //   tab: 1,
    //   hideInTable: true,
    //   Cell: ({ cell }) => <div>{accountLocation.find(at => at.id === cell.row.original.accountLocationId)?.title}</div>
    // },
    {
      header: 'Status',
      ...enumColumn('statusId', statusTypes),
      type: 'dropdown-v2',
      options: statusTypes,
      required: true,
      categoryType: 'general',
      tab: 1,
      size: 35,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false,
    },


    {
      header: 'Account Holder Name',
      accessorKey: 'accountHolderName',
      type: 'text',
      required: true,
      categoryType: 'general',
      tab: 1,
      hideInTable: true
    },
    {
      header: 'Account Holder Address',
      ...enumColumn('accountHolderAddressId', bankAddresses),
      type: 'dropdown-v2',
      options: bankAddresses,
      required: false,
      categoryType: 'general',
      tab: 1,
      hideInTable: true,
    },
    {
      header: 'Bank Name',
      accessorKey: 'bankName',
      type: 'text',
      required: true,
      categoryType: 'bankInfo',
      tab: 1,
      size: 100,
      enableColumnDragging: false,
      enableColumnActions: false,
      enableResizing: false
    },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement40',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'general',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },


    {
      header: 'EE Can Make Changes',
      accessorKey: 'transfereeCanMakeChangesToThisAccount',
      type: 'checkbox',
      required: false,
      categoryType: 'general',
      tab: 0,
      hideInTable: true,
      Cell: ({ cell }) => (
        <Checkbox
          name="transfereeCanMakeChangesToThisAccount"
          checked={!!cell.row.original.transfereeCanMakeChangesToThisAccount}
          disabled={false}
        />
      )
    },
    {
      header: 'EE Can Submit Expense Reports',
      accessorKey: 'transfereeCanSubmitExpenseReportsToThisAccount',
      type: 'checkbox',
      required: false,
      categoryType: 'general',
      tab: 0,
      hideInTable: true,
      Cell: ({ cell }) => (
        <Checkbox
          name="transfereeCanSubmitExpenseReportsToThisAccount"
          checked={!!cell.row.original.transfereeCanSubmitExpenseReportsToThisAccount}
          disabled={false}
        />
      )
    },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement4',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'general',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },
    {
      header: 'Primary Account',
      accessorKey: 'isPrimary',
      type: 'checkbox',
      required: false,
      categoryType: 'general',
      defaultVal: false,
      tab: 1,
      hideInTable: true,
      Cell: ({ cell }) => <Checkbox name="isPrimary" checked={!!cell.row.original.isPrimary} disabled={false} />
    },


    // {
    //   header: 'Default Account',
    //   accessorKey: 'isDefaultAccount',
    //   type: 'checkbox',
    //   required: false,
    //   categoryType: 'general',
    //   defaultVal: false,
    //   tab: 1,
    //   hideInTable: true,
    //   Cell: ({ cell }) => <Checkbox name="isDefaultAccount" checked={!!cell.row.original.isDefaultAccount} disabled={false} />
    // },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'general',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'general',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },

    // {
    //   header: 'Banking Information',
    //   accessorKey: 'generalInformation',
    //   type: 'title',
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   gridSize: 12,
    //   hideInTable: true
    // },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement5',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement6',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },


    // {
    //   header: 'Bank Name',
    //   accessorKey: 'bankName',
    //   type: 'text',
    //   required: true,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   size: 100,
    //   enableColumnDragging: false,
    //   enableColumnActions: false,
    //   enableResizing: false
    // },
    // {
    //   header: 'Bank City',
    //   accessorKey: 'bankCity',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    // },
    // {
    //   header: 'Bank Country',
    //   accessorKey: 'bankCountryId',
    //   type: 'dropdown-v2',
    //   options: renderCountryOptions,
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true,
    //   defaultVal: 'd94a0819-59a2-443f-bc99-1ee360057f38',
    //   Cell: ({ cell }) => <div>{renderCountryOptions.find(c => c.id === cell.row.original.bankCountryId)?.title}</div>
    // },


    // {
    //   header: 'Bank Postal Code',
    //   accessorKey: 'bankPostal',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    // },
    // {
    //   header: 'Bank Phone',
    //   accessorKey: 'bankPhone',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    // },
    // {
    //   header: 'Bank Email',
    //   accessorKey: 'bankEmail',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    // },


    // {
    //   header: 'Payment By',
    //   accessorKey: 'paymentSelector',
    //   type: 'dropdown-v2',
    //   options: [
    //     { id: 0, title: 'Due Date' },
    //     { id: 1, title: 'Discount Date' }
    //   ],
    //   required: false,
    //   defaultVal: 0,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   Cell: ({ cell }) => {
    //     const val = cell.row.original.paymentSelector;
    //     return <div>{val === 1 ? 'Discount Date' : 'Due Date'}</div>;
    //   }
    // },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement7',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },
    // {
    //   header: 'Empty',
    //   accessorKey: 'emptyElement8',
    //   type: 'hidden',
    //   required: false,
    //   categoryType: 'bankInfo',
    //   tab: 1,
    //   hideInTable: true
    //   // hideInModel: true,
    // },


    {
      header: 'Payment Information',
      accessorKey: 'paymentInformation',
      type: 'title',
      categoryType: 'paymentFields',
      tab: 1,
      gridSize: 12,
      hideInTable: true,
      displayDependent: 'paymentTypeId',
      displayDependentVal: [PAYMENT_TYPES.ACH, PAYMENT_TYPES.WIRE, PAYMENT_TYPES.INTERNATIONAL_WIRE]
    },
    {
      header: 'Empty',
      accessorKey: 'emptyElement9',
      type: 'hidden',
      required: false,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true,
      displayDependent: 'paymentTypeId',
      displayDependentVal: [PAYMENT_TYPES.ACH, PAYMENT_TYPES.WIRE, PAYMENT_TYPES.INTERNATIONAL_WIRE]
      // hideInModel: true,
    },
    {
      header: 'Empty',
      accessorKey: 'emptyElement10',
      type: 'hidden',
      required: false,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true,
      displayDependent: 'paymentTypeId',
      displayDependentVal: [PAYMENT_TYPES.ACH, PAYMENT_TYPES.WIRE, PAYMENT_TYPES.INTERNATIONAL_WIRE]
      // hideInModel: true,
    },


    // {
    //   header: 'Account Type',
    //   accessorKey: 'accountTypeId',
    //   type: 'dropdown-v2',
    //   options: accountTypes,
    //   required: false,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   displayDependentVal: [PAYMENT_TYPES.ACH],
    //   Cell: ({ cell }) => <div>{accountTypes.find(at => at.id === cell.row.original.accountTypeId)?.title}</div>
    // },
    {
      header: 'Currency',
      ...currencyColumn('accountCurrencyId'),
      type: 'dropdown-v2',
      options: currencyOptions,
      required: false,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true,
      displayDependent: 'paymentTypeId',
      defaultVal: '7360b8f8-a885-4cc9-a5b1-97233ff79c75',
      displayDependentVal: [PAYMENT_TYPES.ACH, PAYMENT_TYPES.WIRE, PAYMENT_TYPES.INTERNATIONAL_WIRE],
    },
    {
      header: 'Account Number',
      accessorKey: 'accountNumber',
      type: 'text',
      required: true,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true,
      displayDependent: 'paymentTypeId',
      hint: 'Enter 9 digits (US account number)',
      displayDependentVal: [PAYMENT_TYPES.ACH, PAYMENT_TYPES.WIRE]
    },
    {
      header: 'Routing Number',
      accessorKey: 'routingNumber',
      type: 'text',
      required: true,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true,
      displayDependent: 'paymentTypeId',
      hint: 'Enter 9 digits (US routing number)',
      displayDependentVal: [PAYMENT_TYPES.ACH, PAYMENT_TYPES.WIRE]
    },


    {
      header: 'Wire Instructions',
      accessorKey: 'wireInstructionDomestic',
      type: 'text',
      required: false,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true,
      displayDependent: 'paymentTypeId',
      displayDependentVal: [PAYMENT_TYPES.WIRE]
    },
    // {
    //   header: 'IBAN Number',
    //   accessorKey: 'ibanNumber',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   hint: 'Enter 9 digits',
    //   displayDependentVal: [PAYMENT_TYPES.INTERNATIONAL_WIRE]
    // },
    // {
    //   header: 'SWIFT/BIC Code',
    //   accessorKey: 'bankSwiftCode',
    //   type: 'text',
    //   required: true,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   hint: 'Format: AAAABBCCDDD (8 or 11 characters)',
    //   displayDependentVal: [PAYMENT_TYPES.INTERNATIONAL_WIRE]
    // },
    // {
    //   header: 'Further Credit/Reference',
    //   accessorKey: 'wireInstruction',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   displayDependentVal: [PAYMENT_TYPES.INTERNATIONAL_WIRE]
    // },
    {
      header: 'Empty',
      accessorKey: 'emptyElement82',
      type: 'hidden',
      required: false,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true
      // hideInModel: true,
    },
    {
      header: 'Empty',
      accessorKey: 'emptyElement83',
      type: 'hidden',
      required: false,
      categoryType: 'paymentFields',
      tab: 1,
      hideInTable: true
      // hideInModel: true,
    },
    // {
    //   header: 'Intermediary Bank Required',
    //   accessorKey: 'hasIntermedReqd',
    //   type: 'checkbox',
    //   required: false,
    //   defaultVal: false,
    //   categoryType: 'paymentFields',
    //   conditional: true,
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   displayDependentVal: [PAYMENT_TYPES.INTERNATIONAL_WIRE],
    //   Cell: ({ cell }) => <Checkbox name="hasIntermedReqd" checked={!!cell.row.original.hasIntermedReqd} disabled={false} />
    // },
    // {
    //   header: 'Intermediary Bank Name',
    //   accessorKey: 'intermediaryBankName',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   displayDependentVal: [PAYMENT_TYPES.INTERNATIONAL_WIRE],
    //   dependentOn: 'hasIntermedReqd',
    //   dependentValue: true
    // },
    // {
    //   header: 'Intermediary SWIFT/BIC',
    //   accessorKey: 'intermediarySwiftCode',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   hint: 'Format: AAAABBCCDDD (8 or 11 characters)',
    //   displayDependentVal: [PAYMENT_TYPES.INTERNATIONAL_WIRE],
    //   dependentOn: 'hasIntermedReqd',
    //   dependentValue: true
    // },
    // {
    //   header: 'Clabe',
    //   accessorKey: 'clabe',
    //   type: 'text',
    //   required: false,
    //   categoryType: 'paymentFields',
    //   tab: 1,
    //   hideInTable: true,
    //   displayDependent: 'paymentTypeId',
    //   displayDependentVal: [PAYMENT_TYPES.INTERNATIONAL_WIRE]
    // },
    {
      header: 'Special Instructions',
      accessorKey: 'specialInstructions',
      type: 'notes',
      required: false,
      categoryType: 'general',
      tab: 1,
      hideInTable: true
    }
  ];

  // Categories for the modal
  const bankingCategories = [
    {
      id: 0,
      title: 'general',
      label: 'General Information',
      conditionalRender: false
    },
    {
      id: 1,
      title: 'bankInfo',
      label: 'Bank Information',
      conditionalRender: false
    },
    {
      id: 2,
      title: 'achFields',
      label: 'ACH Details',
      conditionalRender: false
    },
    {
      id: 3,
      title: 'wireFields',
      label: 'Domestic Wire Details',
      conditionalRender: false
    },
    {
      id: 4,
      title: 'intlWireFields',
      label: 'International Wire Details',
      conditionalRender: false
    },
    {
      id: 5,
      title: 'paymentSettings',
      label: 'Payment Settings',
      conditionalRender: false
    },
    {
      id: 6,
      title: 'paymentFields',
      label: 'Payment Fields',
      conditionalRender: false
    }
  ];

  const normalizeBankValues = values => {
    const v = values || {};

    return {
      ...v,

      // server expects numeric fileId
      fileId: Number(fileId),

      // text defaults
      bankCity: v.bankCity || '',
      bankPostal: v.bankPostal || '',

      // enum defaults
      bankProvinceId: v.bankProvinceId || EMPTY_GUID,
      bankCountryId: v.bankCountryId || EMPTY_GUID,

      // ensure bools
      isDefaultAccount: !!v.isDefaultAccount,
      isPreferredForWire: !!v.isPreferredForWire,
      isPreferredForACH: !!v.isPreferredForACH,
      hasIntermedReqd: !!v.hasIntermedReqd,

      // ensure ints
      intermedBankingId: v.intermedBankingId ? Number(v.intermedBankingId) : 0,

      // ensure BIGINT FK
      accountHolderAddressId: v.accountHolderAddressId ? Number(v.accountHolderAddressId) : 0,

      // auditing
      addedBy: v.addedBy ? Number(v.addedBy) : 1,
      modifiedBy: v.modifiedBy ? Number(v.modifiedBy) : 1
    };
  };

  const updateBank = async (record, values) => {
    setIsLoading(true);
    const newValues = normalizeBankValues(values);
    const resp = await updateBankFunc(record, newValues);
    setIsLoading(false);
    return resp;
  };

  const createBank = async values => {
    setIsLoading(true);
    const newValues = normalizeBankValues(values);
    const resp = await createBankFunc(newValues);
    setIsLoading(false);
    return resp;
  };

  const deleteBank = async record => {
    setIsLoading(true);
    const resp = await deleteBankFunc(record);
    setIsLoading(false);
    return resp;
  };

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Tooltip title={'File Contract'} key={'banks'} placement="right">
            <FontAwesomeIcon icon={['fas', 'file-contract']} size="2x" />
          </Tooltip>
          <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
            Banking
          </Typography>
        </Box>

        {!isLoading && (
          <CrudTable
            editingMode={'modal'}
            columns={bankingSummaries}
            rows={banks || []}
            updateRow={updateBank}
            createRow={createBank}
            deleteRow={deleteBank}
            customAddText={'Add Bank'}
            hideEdit={isReadOnly}
            hideAdd={isReadOnly}
            categories={bankingCategories}
          />
        )}

        {isLoading && <Spinner />}
      </CardContent>
    </Card>
  );
};

const mapStateToProps = state => {
  const {
    countries,
    bankAccountTypes,
    bankAccountStatuses,
    currencies,
    bankAccountLocationTypes,
    provinces,
    bankAccountPaymentMethodTypes
  } = state.enumerations.allEnums;

  return {
    renderCountryOptionsEnum: countries,
    accountTypesEnum: bankAccountTypes,
    statusTypesEnum: bankAccountStatuses,
    currencyOptionsEnum: currencies,
    accountLocationEnum: bankAccountLocationTypes,
    provinceOptionsEnum: provinces,
    paymentMethodTypesEnum: bankAccountPaymentMethodTypes
  };
};

export default compose(
  connect(mapStateToProps, {
    showToast
  })
)(BankingCard);
